module.exports = __webpack_public_path__ + "static/media/female-blue-v3@2x.4d1ae1f0.png";